module.exports = __webpack_public_path__ + "static/img/banner2.0f5f384c.png";